import { Skeleton, styled } from '@mui/material';

export const SkeletonLoader = styled(Skeleton)`
  height: 14px;
`;
